import {
  GeneralIcon
} from "./chunk-JQYOYMSZ.mjs";

// src/icon/src/general/chevron.tsx
import { jsx } from "react/jsx-runtime";
var ChevronLeftPath = () => /* @__PURE__ */ jsx(
  "path",
  {
    d: "m14.36 18.25-5.955-5.956a.416.416 0 0 1 0-.588l5.956-5.956",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }
);
var ChevronDownPath = () => /* @__PURE__ */ jsx(
  "path",
  {
    d: "m17.572 8.961-5.955 5.956a.416.416 0 0 1-.59 0L5.073 8.96",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }
);
var ChevronRightPath = () => /* @__PURE__ */ jsx(
  "path",
  {
    d: "m9 6 5.956 5.956a.415.415 0 0 1 0 .588L9 18.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }
);
var ChevronUpPath = () => /* @__PURE__ */ jsx(
  "path",
  {
    d: "m5.072 15.039 5.956-5.956a.417.417 0 0 1 .589 0l5.955 5.956",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }
);
var ChevronLeft = (props) => /* @__PURE__ */ jsx(GeneralIcon, { ...props, children: /* @__PURE__ */ jsx(ChevronLeftPath, {}) });
var ChevronUp = (props) => /* @__PURE__ */ jsx(GeneralIcon, { ...props, children: /* @__PURE__ */ jsx(ChevronUpPath, {}) });
var ChevronDown = (props) => /* @__PURE__ */ jsx(GeneralIcon, { ...props, children: /* @__PURE__ */ jsx(ChevronDownPath, {}) });
var ChevronRight = (props) => /* @__PURE__ */ jsx(GeneralIcon, { ...props, children: /* @__PURE__ */ jsx(ChevronRightPath, {}) });

export {
  ChevronLeft,
  ChevronUp,
  ChevronDown,
  ChevronRight
};
